(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('ServicePointFactory', ServicePointFactory);

  ServicePointFactory.$inject = ['$http'];

  /* @ngInject */
  function ServicePointFactory ($http) {
    const service = {
      getServicePointById: getServicePointById,
      getServicePointByAddress: getServicePointByAddress
    };

    return service;

    function getServicePointById (servicePointId) {
      return $http({
        method: 'JSONP',
        jsonpCallbackParam: 'callback',
        url: 'https://api2.postnord.com/rest/businesslocation/v1/servicepoint/getServicePointInformation.json',
        params: {
          servicePointId: servicePointId,
          countryCode: 'SE',
          apikey: 'KEYHERE',
          serviceType: 'SERVICEPOINT',
          requestDropOffTime: true,
          callback: 'JSON_CALLBACK'
        }
      }).then(function (response) {
        const servicePoint = response.data.servicePointInformationResponse.servicePoints[0];

        const res = {
          servicePointId: servicePoint.servicePointId,
          name: servicePoint.name,
          deliveryAddress: servicePoint.deliveryAddress,
          visitingAddress: servicePoint.visitingAddress,
          openingHours: formatOpeningHours(servicePoint.openingHours),
          dropOffTimes: formatDropOffTimes(servicePoint.dropOffTime.dropOffTimeDatas)
        };

        if (servicePoint.coordinates) {
          res.coordinates = {
            lat: servicePoint.coordinates[0].northing,
            lng: servicePoint.coordinates[0].easting
          };
        }

        return res;
      });
    }

    function getServicePointByAddress (address) {
      return $http({
        method: 'JSONP',
        jsonpCallbackParam: 'callback',
        url: 'https://api2.postnord.com/rest/businesslocation/v1/servicepoint/findNearestByAddress.json',
        params: {
          postalCode: address.zipCode,
          city: address.city,
          streetName: address.street,
          numberOfServicePoints: 1,
          apikey: 'KEYHERE',
          countryCode: 'SE',
          callback: 'JSON_CALLBACK'
        }
      }).then(function (response) {
        const servicePoint = response.data.servicePointInformationResponse.servicePoints[0];

        servicePoint.openingHours = formatOpeningHours(servicePoint.openingHours);

        return servicePoint;
      });
    }

    function formatOpeningHours (openingHours) {
      let week = [
        { name: 'monday', hours: [] },
        { name: 'tuesday', hours: [] },
        { name: 'wednesday', hours: [] },
        { name: 'thursday', hours: [] },
        { name: 'friday', hours: [] },
        { name: 'saturday', hours: [] },
        { name: 'sunday', hours: [] }
      ];

      _.each(openingHours, function (d) {
        const day = _.findWhere(week, {name: d.day.toLowerCase()})
          || _.findWhere(week, {name: shortDayNameToLong(d.day)});

        if (d.from1.indexOf(':') === -1) {
          d.from1 = d.from1.substring(0, 2) + ':' + d.from1.substring(2, 4);
          d.to1 = d.to1.substring(0, 2) + ':' + d.to1.substring(2, 4);
        }

        day.hours.push({
          from: d.from1,
          to: d.to1,
          string: d.from1 + ' - ' + d.to1
        });

        if (d.from2 !== undefined && d.to2 !== undefined) {
          if (d.from2.indexOf(':') === -1) {
            d.from2 = d.from2.substring(0, 2) + ':' + d.from2.substring(2, 4);
            d.to2 = d.to2.substring(0, 2) + ':' + d.to2.substring(2, 4);
          }

          day.hours.push({
            from: d.from2,
            to: d.to2,
            string: d.from2 + ' - ' + d.to2
          });
        }
      });

      week = _.groupBy(week, function (day) {
        return _.pluck(day.hours, 'string').join(', ') || 'closed';
      });

      return week;
    }

    function shortDayNameToLong (shortDayName) {
      let longDayName;

      switch (shortDayName.toUpperCase()) {
        case 'MO':
          longDayName = 'monday';
          break;
        case 'TU':
          longDayName = 'tuesday';
          break;
        case 'WE':
          longDayName = 'wednesday';
          break;
        case 'TH':
          longDayName = 'thursday';
          break;
        case 'FR':
          longDayName = 'friday';
          break;
        case 'SA':
          longDayName = 'saturday';
          break;
        case 'SU':
          longDayName = 'sunday';
          break;
      }

      return longDayName;
    }

    function formatDropOffTimes (dropOffTimes) {
      return _.chain(dropOffTimes)
        .map(function (day) {
          return {
            name: day.day,
            latestTime: day.latestTime
          };
        })
        .groupBy('latestTime')
        .value();
    }
  }
})();
